const findOption = function(node, value)
{
	return Array.from(node?.list?.options ?? []).find(option => option.value == value);
};

const normalizeForMatch = function(str)
{
	return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
};

const optionMatchesTyped = function(option, typed)
{
	if (!typed || !option?.innerText) return false;
	const nTyped = normalizeForMatch(typed);
	const nOption = normalizeForMatch(option.innerText);
	return nOption === nTyped || nOption.startsWith(nTyped) || nOption.includes(nTyped);
};

const isValidId = function(val)
{
	if (val == null || val === '' || val === -1 || val === '-1') return false;
	const n = Number(val);
	return !isNaN(n) && n >= 0;
};

const setOption = function(node, callback)
{
	let options = Array.from(node?.list?.options ?? []);
	let option = options.find(callback);
	// -2: invalid, -1: empty. Opcional + sem match: se lista vazia (ex: produto sem estoque), manter texto digitado (-2); senão tratar como vazio (-1)
	let new_value = option?.value ?? (node.value.length ? (this.isRequired() ? -2 : (options.length === 0 ? -2 : -1)) : -1);
	let old_value = this.getValue() ?? -1;
	// Input vazio e campo tem id: só preservar se opções ainda não carregaram (não há option para old_value). Se há option, usuário pode ter limpado de propósito.
	if (new_value === -1 && !node.value.length && isValidId(old_value) && !findOption(node, old_value))
		return void this.refresh();
	if (new_value != old_value)
	{
		this.setValue(new_value);
		this.checkErrorState();
	}
	this.refresh();		// Must be out here or it won't show properly when you clear the field and retype the old value
};

export default function (...args)
{
	return {

		events: ['input', 'blur'],

		checkValue(value = this.getValue())
		{
			let node = document.querySelector(this.selector);
			if (findOption(node, value))
				return true;
			// Campo opcional com id numérico válido: aceitar mesmo sem opção (ex.: lista ainda não carregou)
			if (!this.isRequired() && isValidId(value))
				return true;
			// Campo opcional com valor inválido (-2): tratar como vazio para permitir avançar (usuário digitou algo que não está na lista)
			if (!this.isRequired() && (value == -2 || value == '-2'))
				return true;
			return false;
		},

		isEmpty(value = this.getValue())
		{
			return !value || value == -1;	// Leave the ==, value is string
		},

		refresh()
		{
			let node = document.querySelector(this.selector);
			if (!node || !node.list)
				return;
			let value = this.getValue();
			let option = findOption(node, value);
			if (option)
				node.value = option.innerText;
			else if (value != -2)
				// Opções ainda não carregaram: manter id como fallback em vez de vazio
				node.value = isValidId(value) ? String(value) : '';
		},

		handleEvents(ev)
		{
			switch (ev.type)
			{
				case 'input':														// Event generated when user select an option from the dropdown list
					if (!ev.inputType || ev.inputType == 'insertReplacementText')	// React to list selections only
						setOption.call(this, ev.target, (option) => option.value == ev.target.value || (option.innerText && option.innerText.trim() === String(ev.target.value).trim()));
					break;
				case 'blur':
					let node = document.querySelector(this.selector);
					if (node.value != findOption(node, this.getValue())?.innerText)
						setOption.call(this, ev.target, (option) => ev.target.value.length && (ev.target.value == option.value || optionMatchesTyped(option, ev.target.value)));
					break;
			}
		}

	};
}

